<template>
	<div ref="body">
		<div class="flex space-x-1">
			<div>
				<!-- * je modifie la taille pour que ce soit aligné avec l'input description -->
				<vue-cascader-select
					class="bg-white rounded-md z-10 text-black my-cascader-select"
					@select="(item) => setActions(item.label)"
					:value="currentActionTitle"
					:options="actionDescriptionsList">
				</vue-cascader-select>
			</div>

			<!-- <h3>Description</h3> -->
			<b-form-input
				class="max-w-[65%]"
				@change="change_emit()"
				v-model="description" />
			<div>
				<b-button
					@click="json_step = JSON.stringify(save(), null, 4)"
					v-b-modal="'modal-step' + id"
					><i class="fas fa-edit"></i
				></b-button>
				<b-modal
					:hide-footer="true"
					size="lg"
					:id="'modal-step' + id"
					title="JSON de l'étape">
					<b-form-textarea
						v-model="json_step"
						rows="15"></b-form-textarea>
					<b-button @click="() => load(JSON.parse(json_step))"
						>Appliquer</b-button
					>
				</b-modal>
			</div>
		</div>

		<!-- todo | ici on boucle sur les choix d'actions s'il yen a plusieurs, sinon on affiche simplement -->
		<!-- todo | dans la boucle on aurait un "step-component" qui prend le nom de l'action et récupère ses informations depuis une fonction externe
             todo | (schema, conditions, tabulator, tree, project, etc...)
         -->
		<b-tabs
			active-nav-item-class="font-weight-bold text-uppercase text-success"
			class="mt-2.5"
			no-fade>
			<div
				v-for="(action, i) in actionChoiceDetails"
				:key="'action_' + action.label + '_' + i">
				<!-- * l'attribut lazy permet d'éviter le chevauchement et potentiellement améliore la performance,
                     * mais c'est un peu lent à chaque clic et ça efface le JSON, faudrait qu'on garde une ref aux params -->
				<b-tab
					:title="action.label"
					@click="() => changedActionTab(action.name, action.label)"
                    :active="i === 0 ? true : false">
					<slot :name="action.name"> </slot>
				</b-tab>
			</div>
			<!-- *  -->
			<b-tab>
				<template #title>
					<div class="text-orange-300">Info</div>
				</template>
				<step-info-editor
					v-if="stepInformation !== null"
					@get-step-info="
						(lang) => getStepInfo(actionGroupDesignation, lang)
					"
					@save="
						(title, desc, info, lang) =>
							saveStepInfo(title, desc, info, lang)
					"
					:step-information="stepInformation"
					:id="id"
					:actionGroupDesignation="actionGroupDesignation">
				</step-info-editor>
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
	var clone = require("clone");

	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";
	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	import uniqueId from "lodash.uniqueid";
	import pdf from "vue-pdf";

	import edit_tabulator from "./edit_tabulator.vue";

	import VueCascaderSelect from "vue-cascader-select";
	import request_perso_overview from "./request_perso_overview.vue";
	import step from "../components/Step.vue";

	import mapping_step from "./mapping_step.vue";
	import {
		ActionList,
		GetActionInfo,
		ActionListDescriptionsN1,
		ActionListDescriptionsN2,
		ActionListV2_N1,
		ActionListV2_N2,
	} from "../utils/liste_actions.js";

	import StepInfo from "../services/stepInfo.js";
	import step_info_editor from "../components/step_info_editor.vue";

	export default {
		name: "step-v2",
		components: {
			step,
			pdf,
			edit_tabulator,
			"vue-cascader-select": VueCascaderSelect,
			"request-perso-overview": request_perso_overview,
			"mapping-step": mapping_step,
			"step-info-editor": step_info_editor,
		},
		props: {
			action_choices: {
				type: Array,
				required: true,
				default: () => [],
			},
			load_data: {
				default: null,
			},
			id: {
				default: uniqueId(""),
			},
			actionGroupDesignation: {
				default: "",
			},
			step_index: {
				default: 0,
			},
			start_desc: {
				default: "",
			},
		},
		data() {
			return {
				data: {
					uid: this.$uuid.v4(),
				},
				description: this.start_desc,
				action: "",
				actionLabel: "Nouvelle étape",

				json_step: {},

				selectedAction: "",

				error: false,

				source_data: "",
				file_result: false,

				actionChoiceDetails: [],

				actionDescriptionsN1: ActionListDescriptionsN1(),
				actionDescriptionsN2: ActionListDescriptionsN2(),

				actionDescriptionsList: [
					...ActionListV2_N1(),
					...ActionListV2_N2(),
				],
				currentActionTitle: "",

				stepInformation: null,
			};
		},
		computed: {
			currentStepRef: function () {
				let refName =
					this.selectedAction.replace(/ /g, "-") + "-ref-" + this.id;

				return refName;
			},
		},
		methods: {
			async getStepInfo(name, lang) {
				this.stepInformation = await StepInfo.GetByName(name, lang);
				// console.log(`Getting info for ${name} in ${lang} `, clone(this.stepInformation));
			},
			async saveStepInfo(title, desc, info, lang) {
				this.stepInformation.title = title;
				this.stepInformation.description = desc;
				this.stepInformation.info = info;
				this.stepInformation.lang = lang;
                this.stepInformation.name = this.actionGroupDesignation;

				let result = await StepInfo.CreateOrUpdate(this.stepInformation);
                // console.log("Result of create/update step info: ", result);
			},
			setActions(actionTitle) {
				var totalActionGroups = [
					...this.actionDescriptionsN1,
					...this.actionDescriptionsN2,
				];
				console.log("Total action groups: ", totalActionGroups);
				var fullActionGroup = totalActionGroups.find((item) => {
					return item.title === actionTitle;
				});

				console.log("Setting new action group: ", fullActionGroup);

				this.$parent.updateStepV2(fullActionGroup, this.step_index);
			},
			composeActionId(actionName, identifier) {
				let hyphenatedActionName = actionName.replace(/ /g, "-");

				return `${hyphenatedActionName}-${identifier}-${this.id}`;
			},
			arrayObjToObj(toChange) {
				let obj = {};

				Object.keys(toChange).forEach(function (key) {
					obj[key] = toChange[key];
				});
				return obj;
			},
            load(json_data) {
				// * utilise les refs pour appeler load() de chaque step
				this.$parent.$refs[this.id][0].load(json_data);
            },
			save() {
				// * utilise les refs pour appeler save() de chaque step

				// console.log("Current data: ", clone(this.data));

				let savedStepResult = this.$parent.$refs[this.id][0].save();

				// console.log("Got saved step result: ", clone(savedStepResult));

				// * c'est step v2 qui contient description, et action ?
				savedStepResult.description = this.description;

				// * il faudra la liste des actions
				savedStepResult.action_choices = this.action_choices;
				// console.log("Saving action choices: ", savedStepResult.action_choices);

				// console.log("Saved step parent: ", clone(savedStepResult));
				console.log("Saved result: ", clone(savedStepResult));
				return savedStepResult;
			},
			changedActionTab(actionName, actionLabel) {
				// * modify parent refs, current step id needs to be first in the array
				// this.$refs[this.currentStepRef][0].id = this.id;

				// * loop over parent refs
				for (let i = 0; i < this.$parent.$refs[this.id].length; i++) {
					let actionRef = this.$parent.$refs[this.id][i];
					let actionRefName = actionRef.getAction();

					if (actionRefName === actionName && i !== 0) {
						// switch places in array
						console.log(
							"First action before: ",
							this.$parent.$refs[this.id][0].getAction()
						);
						let tmp = this.$parent.$refs[this.id][0];
						this.$parent.$refs[this.id][0] =
							this.$parent.$refs[this.id][i];
						this.$parent.$refs[this.id][i] = tmp;
						console.log(
							"Parent first action after: ",
							this.$parent.$refs[this.id][0].getAction()
						);
						break;
					}
				}

				this.selectedAction = actionName;
				this.action = actionName;
				this.actionLabel = actionLabel;
			},
			change_emit() {
				// * change la description dans ton enfant
				this.$emit("change", this.id, this.description);
			},
		},
		created: function () {},
		async mounted() {
			this.actionChoiceDetails = [];
			for (var i = 0; i < this.action_choices.length; i++) {
				this.actionChoiceDetails.push(
					GetActionInfo(this.action_choices[i])
				);
			}

			this.selectedAction = this.actionChoiceDetails[0].name;

			this.currentActionTitle = this.actionGroupDesignation;

			// console.log("Action group designation: ", this.actionGroupDesignation);
			this.stepInformation = await StepInfo.GetByName(
				this.actionGroupDesignation
			);
			// console.log("Got stepInformation: ", this.stepInformation);
		},
		watch: {},
		beforeDestroy() {},
	};
</script>

<style>
	/* * pour que ce soit de la même hauteur que l'input description à côté 
    (formule prise de la classe form-control) */
	.vcs__picker input {
		height: calc(1.5em + 0.75rem + 2px) !important;
	}
</style>

<style scoped>
	.sub-menu {
		position: absolute;
		min-width: 10rem;
		padding: 0.5rem 0;
		margin: 0.125rem 0 0;
		font-size: 1rem;
		color: #212529;
		text-align: left;
		list-style: none;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid rgba(0, 0, 0, 0.15);
		border-radius: 0.25rem;
	}
</style>
